import { useCallback } from 'react';
import { useTranslation } from '@packlink/translation-provider';
import { useTenantConfig } from '@packlink/tenant-config-provider';

function useHelpCenter() {
  var _useTenantConfig;
  const {
    helpCenter
  } = (_useTenantConfig = useTenantConfig()) !== null && _useTenantConfig !== void 0 ? _useTenantConfig : {};
  const {
    i18n
  } = useTranslation();
  const getHelpCenterPage = useCallback(page => {
    var _helpCenter$articles$, _helpCenter$articles$2, _helpCenter$baseUrl;
    return page ? (_helpCenter$articles$ = helpCenter === null || helpCenter === void 0 ? void 0 : (_helpCenter$articles$2 = helpCenter.articles[page]) === null || _helpCenter$articles$2 === void 0 ? void 0 : _helpCenter$articles$2[i18n.language]) !== null && _helpCenter$articles$ !== void 0 ? _helpCenter$articles$ : '' : (_helpCenter$baseUrl = helpCenter === null || helpCenter === void 0 ? void 0 : helpCenter.baseUrl) !== null && _helpCenter$baseUrl !== void 0 ? _helpCenter$baseUrl : '';
  }, [helpCenter, i18n]);
  return getHelpCenterPage;
}

export { useHelpCenter };
//# sourceMappingURL=useHelpCenter.js.map
